// Opciones compartidas para el perfil de comprador
// Usadas en BuyerProfileWizard (comprador) y AdminBuyerProfileModal (administrador)
// ⚠️ Si añades/modificas opciones, se reflejan automáticamente en ambos sitios

export const PAYMENT_OPTIONS = [
  { value: 'cash', label: 'Pago al contado', labelKey: 'questions.payment.cash' },
  { value: 'finance_under_60', label: 'Menos del 60% de financiación', labelKey: 'questions.payment.financeUnder60' },
  { value: 'finance_60_80', label: 'Entre el 60% y el 80% de financiación', labelKey: 'questions.payment.finance6080' },
  { value: 'finance_over_80', label: 'Más del 80% de financiación', labelKey: 'questions.payment.financeOver80' },
  { value: 'undecided', label: 'Sin decidir / Explorar opciones', labelKey: 'questions.payment.undecided' },
];

export const FINANCING_OPTIONS = [
  { value: 'preapproved', label: 'Sí, preaprobada', labelKey: 'questions.financing.preapproved' },
  { value: 'in_process', label: 'En proceso', labelKey: 'questions.financing.inProcess' },
  { value: 'not_started', label: 'Todavía no ha empezado', labelKey: 'questions.financing.notStarted' },
  { value: 'no_need', label: 'Sin hipoteca (pago al contado)', labelKey: 'questions.financing.noNeed' },
];

export const PROPERTY_TO_SELL_OPTIONS = [
  { value: 'no', label: 'No', labelKey: 'questions.sell.no' },
  { value: 'signed_deposit', label: 'Sí, con arras firmadas', labelKey: 'questions.sell.signedDeposit' },
  { value: 'on_sale', label: 'Sí, en venta', labelKey: 'questions.sell.onSale' },
  { value: 'not_yet_listed', label: 'Sí, aún no está en venta', labelKey: 'questions.sell.notListed' },
];

export const OUTDOOR_OPTIONS = [
  { value: 'required', label: 'Imprescindible', labelKey: 'questions.features.required' },
  { value: 'desirable', label: 'Deseable', labelKey: 'questions.features.desirable' },
  { value: 'not_needed', label: 'No necesario', labelKey: 'questions.features.notNeeded' },
];

export const REFORM_OPTIONS = [
  { value: 'move_in_ready', label: 'Para entrar a vivir', labelKey: 'questions.features.moveInReady' },
  { value: 'willing_to_reform', label: 'Dispuesto a reformar', labelKey: 'questions.features.willingToReform' },
];

export const FEATURE_OPTIONS = [
  { value: 'required', label: 'Imprescindible', labelKey: 'questions.features.required' },
  { value: 'desirable', label: 'Deseable', labelKey: 'questions.features.desirable' },
  { value: 'not_needed', label: 'No necesario', labelKey: 'questions.features.notNeeded' },
];
